import React from "react";

export default function DetailProductModal({ onClose, product, onEdit }) {
    const formatarParaBRL = (valor)  => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(valor);
    }

    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black/70 backdrop-blur-md z-50 p-4">
            <div className="glass-panel p-0 w-full max-w-5xl bg-[#0f172a]/95 shadow-2xl border border-white/10 relative overflow-hidden flex flex-col max-h-[90vh]">
                
                {/* Header Superior (Sticky) */}
                <div className="flex justify-between items-start p-6 border-b border-white/5 bg-white/[0.02]">
                    <div>
                        <div className="flex items-center gap-3">
                            <span className="bg-white/10 text-white text-xs px-2.5 py-1 rounded-md border border-white/10 font-semibold tracking-wider uppercase">
                                {product.categoria}
                            </span>
                        </div>
                        <h2 className="text-2xl font-bold text-white tracking-wide mt-2">
                            Produto - {product.nome}
                        </h2>
                        <p className="text-gray-400 mt-1 text-sm font-medium">Cód: {product.id}</p>
                    </div>
                    
                    <div className="flex items-center space-x-3">
                        {onEdit && (
                            <button 
                                onClick={onEdit}
                                className="glass-button bg-white/5 hover:bg-white/10 text-gray-200 px-4 py-2 flex items-center text-sm font-medium transition-colors"
                            >
                                <svg className="w-4 h-4 mr-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                </svg>
                                Editar
                            </button>
                        )}
                        <button onClick={onClose} className="p-2 text-gray-400 hover:text-white transition-colors ml-2">
                            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Conteúdo Rolável */}
                <div className="p-8 overflow-y-auto custom-scrollbar flex-1">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        
                        {/* Coluna Esquerda: Valores e Estoque */}
                        <div className="space-y-6">
                            <h3 className="text-lg font-semibold text-gray-200 mb-4 flex items-center">
                                Valores e Estoque
                            </h3>

                            {/* Card Financeiro */}
                            <div className="bg-[#102422] border border-green-500/20 rounded-xl p-5 shadow-[0_0_15px_rgba(34,197,94,0.05)] relative overflow-hidden">
                                <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/5 rounded-full -mr-10 -mt-10 blur-2xl"></div>
                                <div className="flex items-center text-green-400 mb-4 relative z-10">
                                    <svg className="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <span className="font-medium text-sm">Financeiro</span>
                                </div>
                                <div className="grid grid-cols-2 gap-4 relative z-10">
                                    <div>
                                        <p className="text-xs text-green-500/70 mb-1">Custo</p>
                                        <p className="text-lg font-semibold text-green-400/80">{formatarParaBRL(product.valor)}</p>
                                    </div>
                                    <div>
                                        <p className="text-xs text-green-500/70 mb-1">Venda</p>
                                        <p className="text-2xl font-bold text-green-400">{formatarParaBRL(product.valor_venda)}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Card Estoque */}
                            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
                                <div className="flex items-center text-gray-300 mb-4">
                                    <svg className="w-5 h-5 mr-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                    </svg>
                                    <span className="font-medium text-sm">Estoque</span>
                                </div>
                                <div>
                                    <p className="text-xs text-gray-500 mb-1">Quantidade Disponível</p>
                                    <div className="flex items-baseline space-x-2">
                                        <p className="text-2xl font-bold text-gray-200">{product.quantidade}</p>
                                        <span className="text-sm text-gray-500 font-medium">unidades</span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* Coluna Direita: Detalhes e Descrição */}
                        <div className="space-y-6">
                            <h3 className="text-lg font-semibold text-gray-200 mb-4 flex items-center">
                                Detalhes
                            </h3>

                            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
                                <div className="flex items-center text-gray-300 mb-4">
                                    <svg className="w-5 h-5 mr-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7" />
                                    </svg>
                                    <span className="font-medium text-sm">Descrição Completa</span>
                                </div>
                                <p className="text-sm text-gray-300 leading-relaxed min-h-[120px]">
                                    {product.descricao || "-"}
                                </p>
                            </div>
                            
                        </div>
                    </div>
                </div>

                {/* Footer Fixo */}
                <div className="p-4 border-t border-white/5 bg-white/[0.02]">
                    <button
                        onClick={onClose}
                        className="glass-button bg-white/5 hover:bg-white/10 text-gray-300 w-full py-2.5 font-medium transition-colors border border-white/5"
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
}
